<!--
Use this to set a standard block width. You can nest it in itself like this (note the noPadding attribute):
WidthWrapper
  WidthWrapper noPadding width="text"
    TEXT CONTENT
  /WidthWrapper
  BLOCK CONTENT
/WidthWrapper

If the parent WidthWrapper has width="full", don't use the noPadding attribute
-->

<template>
  <div class="width-wrapper mx-auto h-full" :class="widthClass">
    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  width: {
    type: String,
    default: 'block',
    validator: (value) => ['text', 'block', 'button', 'full'].includes(value),
  },
  hasWidth: {
    type: Boolean,
    default: true,
  },
  // If, nesting this component inside itself, set this to true
  noPadding: {
    type: Boolean,
    default: false,
  },
})

const widthClass = computed(() => {
  let widthClass = ''

  if (props.width === 'full') {
    return ''
  }

  if (props.hasWidth) {
    const widthMap = {
      text: 'max-w-prose xl:max-w-4xl',
      block: 'max-w-5xl',
      button: 'max-w-xs sm:max-w-max',
    }

    widthClass = widthMap[props.width]
    if (!props.noPadding) {
      const paddingMap = {
        text: 'px-4 sm:px-6 md:px-0',
        block: 'px-4 sm:px-6 lg:px-8 xl:px-0',
        button: '',
      }

      widthClass += ` ${paddingMap[props.width]}`
    }
  }

  return widthClass
})
</script>
